export default {
    toggle: function(selector, prop, from, to) {
        const el = document.querySelector(selector);
        if (getComputedStyle(el)[prop] == from) el.style[prop] = to;
        else el.style[prop] = from;
    },
    tranStatus: function(value) {
        const status = {
            pending: "En attente",
            processing: "En cours",
            completed: "Terminee",
            canceled: "Annulee"
        }
        return status[value];
    }, 
    getCountryCode: function(countryCode) {
        if(countryCode){
            return "https://static.dwcdn.net/css/flag-icons/flags/4x3/" + countryCode.toLowerCase() + ".svg";
        }
    },
    getCountryNameByCode: function(data,Code) {
        for(var prop in data){
            if(data.hasOwnProperty(prop)){
                if(data[prop]['code'] === Code) {
                    return data[prop]['name'];
                    break;
                }
            }
        }
    },
    getCurrencyByCode: function(data,Code) {
        for(var prop in data){
            if(data.hasOwnProperty(prop)){
                if(data[prop]['code'] === Code) {
                    return data[prop]['currencyCode'];
                    break;
                }
            }
        }
    },
    getcurrencyCodeByCountry: function(data,country) {
        for(var prop in data){
            if(data.hasOwnProperty(prop)){
                if(data[prop]['code'] === country) {
                    return data[prop]['currencyCode'];
                    break;
                }
            }
        }
    },
    getIdbySplit: function(id) {
        let NewId="";
        if(id){
        var lengthId=id.toString().split('-').length;

        if(lengthId==1){
            return id.toString().split('-')[0];
        }else{
            for(let i in id.split('-')){
                if(i != id.split('-').length - 1){
                    NewId+=id.split('-')[i];
                    if(id.split('-').length-2 != i) NewId+='-';
                }
                
            }
            return NewId;
        }
      }
    },
    getElementInArrayByCountry(data,country,qte,manuelCreate=null){
        console.log('details pr----------',data)
        console.log('country----------',country)
        console.log('qte----------',qte)
       
        var result  = data.filter(function(o){
           if(!manuelCreate) return o.warehouse.country === country && o.warehouse.parent && o.warehouse.parent._id && o.quantity.inStock && o.quantity.inStock>=qte && !o.outOfStock;
           else return o.warehouse.country === country && o.warehouse.parent && o.warehouse.parent._id;
        });
      //  console.log('result warehouse--------',result)

        return result? result : null; // or undefined
    },
    getCountryCodeByName: function(data,Name) {
        for(var prop in data){
            if(data.hasOwnProperty(prop)){
                if(data[prop]['name'] === Name) {
                    return data[prop]['code'];
                    break;
                }
            }
        }
    },
    objectToQueryString: function(obj) {
        var str = [];
        var s = document.location.search;
        for (var p in obj)
          if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]).replace(/%2C/g,","));
          }
          window.history.pushState('', '', '?'+str.join("&"));
    },
    
    QueryStringToobject: function() {
        var search = location.search.substring(1);
        if(search) return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
        else return null
    },
    getAccess: function(permissions,modelToCheck, accessToCheck) {
        for (let i in permissions) {
          let model = permissions[i]["model"];
          let access = permissions[i]["access"];
  
          if (model == modelToCheck) {
            return access[accessToCheck];
          }
        }
      },
    getAccessPermission: function(user,modelToCheck,accessToCheck) {
        if (user && user.role && user.role.permissions) {
            const permissions = user.role.permissions;
            for (let i in permissions) {
              let model = permissions[i]["model"];
              let access = permissions[i]["access"];
      
              if (model == modelToCheck) {
                return access[accessToCheck];
              }
            }
        }
      },
      validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(str);
      },
      ColorsStatusShippings: (item) => {
        switch (item) { 
            case 'to prepare':
                return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
                break;
            case 'outofstock':
                return "color: rgb(203 21 160); border-color: rgb(203 21 160);"
                break;
            case 'prepared':
                return "color:rgb(8, 194, 226); border-color: rgb(8, 194, 226);"
                break;
            case 'shipped':
                return "color:rgb(106 71 9); border-color: rgb(106 71 9);"
                break;
            case 'delivered':
                return "color:rgb(58 217 18); border-color: rgb(58 217 18);"
                break;
            case 'paid':
                return "color:rgb(194, 168, 27); border-color: rgb(194, 168, 27);"
                break;
            case 'processed':
                return "color:rgb(215, 26, 230); border-color: rgb(215, 26, 230);"
                break;            
            case 'cancelled':
                return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);"
                break;
            case 'refused':
                    return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);"
                    break;
            case 'remind':
                return "color: rgb(227 129 210); border-color: rgb(227 129 210);"
                break;    
            case 'unreachable':
                return "color: rgb(141 8 118); border-color: rgb(141 8 118);"
                break;
                case 'pending return':
                    return "color: rgb(227 129 210); border-color: rgb(227 129 210);"
                    break;    
                case 'return':
                    return "color: rgb(141 8 118); border-color: rgb(141 8 118);"
                    break;    
        }
    },
    removeCountryByTwoArray(array1, array2) {
        //  return array1.filter(item => array2.map(el => el.code||el).includes(item.country));
        return array1;
      },
      defaultCategories(){
          return ["Électronique", 'Vêtements', 'Maison et jardin', 'Alimentation et boissons', 'Santé et beauté', 'Sports et loisirs', 'Automobile et moto', 'Bébé et enfant', 'Animaux de compagnie', 'Électroménager', 'Outils et bricolage', 'Bijoux et montres', 'Cosmétique'];
      },
      splitArrayIntoChunks(array, chunkSize) {
          let result = [];
          for (let i = 0; i < array.length; i += chunkSize) {
              result.push(array.slice(i, i + chunkSize));
          }
          return result;
      },
      removeObjectKey(obj, key) {
          if (obj.hasOwnProperty(key)) {
              delete obj[key];
          }
          return obj;
      },
      checkMarketplace(data,type,currency=null){
        let marketplace = data.filter(item => item.marketplace && item.marketplace.seller); 
        
        if(type === 'fees'){
           let feesData=0;
    
            if(marketplace.length>0){
                feesData = marketplace.reduce((sum, item) => {
                  if (item.marketplace && item.marketplace.price) {
                    return parseFloat(sum) + parseFloat(item.marketplace.price) * parseInt(item.quantity);
                  }
                  return sum;
                }, 0);
    
            }
    
            return feesData;
    
        }else if(type === 'feesInvoice'){
          let feesData=0;
    
          let marketplaces = data.filter(item => item.currency.toUpperCase() === currency.toUpperCase() && item.marketplaces && item.marketplaces.length>0); 
          console.log('marketplaces data-----',data)
          console.log('marketplaces currency-----',currency.toUpperCase())
          console.log('marketplaces feesInvoice-----',marketplaces)
    
           if(marketplaces.length>0){
               marketplaces= marketplaces.flatMap(p => p.marketplaces);
               
               feesData = marketplaces.reduce((sum, item) => {
                 if (item.price) {
                   return parseFloat(sum) + parseFloat(item.price) * parseInt(item.quantity);
                 }
                 return sum;
               }, 0);
    
           }
    
           return feesData;
    
       }else if(type === 'feesPayment'){
          let feesData=0;
    
           if(data.length>0){
               feesData = data.reduce((sum, item) => {
                 if (item.price) {
                   return parseFloat(sum) + parseFloat(item.price) * parseInt(item.quantity);
                 }
                 return sum;
               }, 0);
    
           }
    
           return feesData;
    
       }else{
          if(marketplace.length>0) marketplace = marketplace.map(item => ({
              price: item.marketplace.price,
              seller: item.marketplace.seller,
              product: item.marketplace.product,
              productSeller: item.product._id||item.product,
              quantity: item.quantity
          }));
    
          return marketplace;
        } 
      },
      getSettingByCountry(datas,country){
        let currentSettings = { info: { currency: "" } };
        const dataCountry= datas.find( (el) => el.country === country );
        if(dataCountry) currentSettings=dataCountry;
        return currentSettings;
      },
      getPriceMarket(data){
        let total=0;
        const serviceFee = data.serviceFees / 100; // 10%
    
        const totalAmount = parseFloat(data.price) * parseInt(data.quantity); // 600
        total = totalAmount * (1 - serviceFee); // 600 * 0.9 = 540
    
        return Math.floor(total);
     },
     sortByAnyDate(arr, { order = 'desc', keys = ['createdAt','date','updatedAt'] } = {}) {
      if (!Array.isArray(arr)) return []
    
      const toTs = (v) => {
        if (!v) return NaN
        if (v instanceof Date) return v.getTime()
        const n = Number(v)
        // يدعم timestamp بالأرقام (ms) أو string ISO
        return Number.isFinite(n) ? n : Date.parse(v)
      }
    
      const getDateTs = (obj) => {
        for (const k of keys) {
          if (obj && obj[k] != null) {
            const t = toTs(obj[k])
            if (!Number.isNaN(t)) return t
          }
        }
        return -Infinity // العناصر بلا تاريخ تمشي لآخر اللائحة فـ 'desc'
      }
    
      const factor = order === 'asc' ? 1 : -1
      return [...arr].sort((a, b) => (getDateTs(a) - getDateTs(b)) * factor)
    },
    totalPriceSourcingMAD(formData) {
      const { details, fees, includeExpFees, promoCode } = formData;
    
      // total items
      const itemsTotal = details.reduce(
        (a, curr) => a + (parseFloat(curr.priceDH || 0) * parseFloat(curr.quantity || 0)),
        0
      );
    
      // extra fees
      const feesTotal = fees.reduce(
        (a, curr) => a + parseFloat(curr.priceDH || 0),
        0
      );
    
      // expedition fees
      const expFees = includeExpFees
        ? details.reduce(
            (a, curr) =>
              a +
              (parseFloat(curr.quantity || 0) * parseFloat(curr.pricePerKgMAD || 0)) +
              parseFloat(curr.recoveryFeeMAD || 0),
            0
          )
        : 0;
    
      // promo discount
      const subtotal = itemsTotal + feesTotal + expFees;
     // console.log('Subtotal before discount:', subtotal);
      const discount = promoCode ? Math.round((itemsTotal + feesTotal) * (promoCode.discount / 100)) : 0;
    
      return (subtotal - discount);
    },
     applyPromoCodeToDetailsPayment(promoCodeData, details = []) {
      if(promoCodeData.promoCode) promoCodeData.code = promoCodeData.promoCode;
      if(promoCodeData.discountPercentage) promoCodeData.discount = promoCodeData.discountPercentage;
    
      if (!promoCodeData || typeof promoCodeData.discount !== 'number') return null;
    
    
      const { code = null, discount = 0 } = promoCodeData;
    
      // regrouper par currency
      const currencyGroups = details.reduce((acc, detail) => {
        const currency = detail.currency;
        const shippingVat = Number(detail.shipping_vat);
    
        if (!acc[currency]) acc[currency] = { originalFees: 0, count: 0, currency };
        acc[currency].originalFees += shippingVat;
        acc[currency].count += 1;
        return acc;
      }, {});
    
      // calcul finalFees par currency
      const feesShipping = Object.values(currencyGroups).map(group => {
        const discountAmount = (group.originalFees * discount) / 100;
        return {
          currency: group.currency,
          originalFees: Number(group.originalFees.toFixed(2)),
          discountPercent: discount,
          discountAmount: Number(discountAmount.toFixed(2)),
          fees_amount: Number(discountAmount.toFixed(2)),
          finalFees: Number((group.originalFees - discountAmount).toFixed(2)),
          count: group.count
        };
      });
    
    
      const promoCode = {
        code,
        discount,
        feesShipping
      };
    
      return { promoCode };
    },
    isNumeric(str) {
        return (
          !isNaN(str) && !isNaN(parseFloat(str)) // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        ); // ...and ensure strings of whitespace fail
      },
    
      isValidAmount(amount) {
        return (
          !isNaN(amount) &&
          Number(amount) > 0 &&
          String(amount)[0] !== "+" &&
          String(amount)[0] !== "-"
        );
      },
      
}